'use client';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import {
  IconArrowRight,
  IconRosetteDiscountCheck,
  IconAlertCircle,
  IconX,
} from '@tabler/icons-react';
import { AlertContext, AlertProps } from '../contexts/alert';

export const AlertProvider = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  const [alert, setAlert] = useState<AlertProps>({
    show: false,
  });

  const handleAlertClose = () => {
    setAlert({
      show: false,
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleAlertClose();
    }, alert.duration || 3000);

    return () => clearTimeout(timer);
  }, [alert.duration, alert.show]);

  return (
    <AlertContext.Provider value={setAlert}>
      {children}
      {alert.show && (
        <div className="fixed bottom-4 right-4 m-4 flex items-start bg-black-100 text-white rounded-xl p-4 gap-5 z-50">
          {alert.severity === 'success' && (
            <div className="rounded-[28px] border-[6px] border-primary-900 bg-primary-800 p-[10px]">
              <IconRosetteDiscountCheck className="text-white" size={20} />
            </div>
          )}
          {alert.severity === 'error' && (
            <div className="rounded-[28px] border-[6px] border-red-900 bg-red-800 p-[10px]">
              <IconAlertCircle className="text-white" size={20} />
            </div>
          )}
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              {alert.title && (
                <span className="text-sm font-bold">{alert.title}</span>
              )}
              {alert.message && (
                <span className="text-sm max-w-[300px]">{alert.message}</span>
              )}
            </div>
            {alert.ctaUrl && (
              <Link className="flex gap-2 items-center" href={alert.ctaUrl}>
                <span className="text-primary-500 text-sm font-bold">View</span>
                <IconArrowRight className="text-primary-500" size={20} />
              </Link>
            )}
          </div>
          <button className="p-1" onClick={handleAlertClose}>
            <IconX className="text-gray-300" />
          </button>
        </div>
      )}
    </AlertContext.Provider>
  );
};
